import React, { CSSProperties, ReactNode } from "react";

import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { Row } from "components/Layout";
import { DialogTitle } from "components/MaterialDialog";
import OnlineStatus from "components/OnlineStatus";

import { getDashboardFetchingStatus, getOnlineStatus } from "selectors";
import { ClickableCommentIcon } from "components/Comments/Icon";
import { CommentTypes } from "constants/comments";

interface ModalTitleProps {
  onClose: () => void;
  children: ReactNode;
  style?: CSSProperties;
  saleLotId?: string;
}

export const ModalTitle = ({
  children,
  onClose,
  saleLotId,
  style,
}: ModalTitleProps) => {
  const onlineState = useSelector(getOnlineStatus);
  const isFetchingDashboardData = useSelector(getDashboardFetchingStatus);

  return (
    <DialogTitle onClose={onClose} style={style}>
      <Row fullWidth flex alignCenter paddingHorizontal={2} maxHeight="42px">
        <Grid item container xs={saleLotId ? 6 : 9} alignItems="center">
          {children}
        </Grid>

        <Grid item xs={saleLotId ? 4 : 3}>
          <OnlineStatus
            status={onlineState.status}
            pendingChangesCount={onlineState.changesOutboxSize}
            isFetching={isFetchingDashboardData}
            textColor="black"
          />
        </Grid>
        {saleLotId && (
          <Grid item xs={2} container justifyContent="flex-end">
            <ClickableCommentIcon
              commentType={CommentTypes.SALE_LOT}
              commentTypeId={saleLotId}
              returnTo={window.location.hash}
            />
          </Grid>
        )}
      </Row>
    </DialogTitle>
  );
};
